import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { superCall as _$su, extend as _$ex, EMPTY_OBJ as _$em, createUnknownComponentVNode as _$cc, className as _$cn, noop as _$no } from 'intact-vue-next';
import { SelectMenu } from './menu';
import { isEmptyChildren } from '../utils';
export default function ($props, $blocks, $__proto__) {
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    autoDisableArrow = _this$get.autoDisableArrow,
    disabled = _this$get.disabled,
    multiple = _this$get.multiple,
    value = _this$get.value;
  var _this$filterable = this.filterable,
    getCreatedVNode = _this$filterable.getCreatedVNode,
    filter = _filterInstanceProperty(_this$filterable);
  var options = filter(children);
  var allShowedValues = this.getAllShowedValues(options);
  var isDisableArrow = disabled || autoDisableArrow && (isEmptyChildren(options) || allShowedValues.length === 1 && !multiple && allShowedValues[0] === value);
  return _$su.call($this, {
    'isDisableArrow': isDisableArrow
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['base-menu'] = function ($super) {
      return _$cc(SelectMenu, {
        'className': _$cn(className),
        'values': allShowedValues,
        'children': (_$blocks['menu'] = function ($super) {
          return [getCreatedVNode(options), options];
        }, __$blocks['menu'] = function ($super, data) {
          var block = $blocks['menu'];
          var callBlock = function callBlock() {
            return _$blocks['menu'].call($this, $super, data);
          };
          return block ? block.call($this, callBlock, data) : callBlock();
        }, __$blocks['menu'](_$no))
      });
    }, __$blocks['base-menu'] = function ($super, data) {
      var block = $blocks['base-menu'];
      var callBlock = function callBlock() {
        return _$blocks['base-menu'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;